import { cva } from 'class-variance-authority'

export const missingStatementsStyles = cva(
  `
    relative
    flex
    flex-col
    background-priority-1
    text-orange
    break-words
  `
)
